module.exports = __webpack_public_path__ + "static/media/ecommerce.0a7ea63e.png";